import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/router';

/**
 * Root Application Component
 * 
 * Standardized Root Wrapper. Side effects (routing logic, scroll, analytics) 
 * are handled within Child Components of the <BrowserRouter>.
 */
function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;